module.exports = __webpack_public_path__ + "img/icon-60.3e55a665.png";